/**
 * Service/BsBackup Controller
 *
 * Displays information about a Baas Managed Backup
 */

// the constructor for this object
function ServiceBsBackupController() { }

// the object
ServiceBsBackupController.prototype = {
    constructor: ServiceBsBackupController,
    
    // the resource id
    resourceId: false,
    
    // the base order id
    baseOrderId: false,
    
    // the start time for backups table
    backupsStartDate: null,
    
    // the end time for backups table
    backupsEndDate: null,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 15,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // set up the pagination
        this._setupPagination();
        
        PortalHelper.debugMessage('Service Baas Backup Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
        
        // get and populate the order
        this._getOrder();
        
        // get/populate the managed backup
        this._getBsManagedBackup();
        
        // get managed backups of the resource
        this._getBsResourceBackups();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Baas Backup Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // get base order and resource id
        if (segments.length == 2) {
            this.baseOrderId = segments[0];
            this.resourceId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#backups-pagination';
        pagination.contentSelector = '#backups-table';
        pagination.eventCallback = PortalMain.ServiceBsBackupController._getBsResourceBackups;
        PortalMain.ServiceBsBackupController.pagination = pagination;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#backup-range-selection-dropdown');
        $('#backups-range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceBsBackupController._updateBackupsRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceBsBackupController._updateBackupsSelectedRange(this);
        });
    },
    
    // get the order from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        PortalMain.ServiceIndexController.showOrderLink = true;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get BaaS specific order info (usage information)
    _getBsManagedBackup: function()
    {
        var dsVmRequest = new PortalRequest;
        dsVmRequest.makeRequest(
            '/orders-bs/get-bs-managed-backup',
            {
                resourceId: this.resourceId,
            },
            function(data) {
                PortalMain.ServiceBsBackupController._populateBackupInfo(data);
                
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#backup-details', false);
                PortalHelper.loadingOverlay('.stats', false);
            }
        )
    },
    
    // fill in the backup info
    _populateBackupInfo: function(backup)
    {
        // set the VM name
        $('#backup-details .backup-name').html(backup.title);
    },
    
    // get managed backups
    _getBsResourceBackups: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceBsBackupController.pagination.getBaseSubmissionData();
        
        // defaulting to 1 month range if a start or end date not passed
        if(!(PortalMain.ServiceBsBackupController.backupsStartDate instanceof Date) 
        || !(PortalMain.ServiceBsBackupController.backupsEndDate instanceof Date)) {
            PortalMain.ServiceBsBackupController.backupsStartDate = new Date();
            PortalMain.ServiceBsBackupController.backupsEndDate = new Date();
            
            // get a years worth of data
            PortalMain.ServiceBsBackupController.backupsStartDate.setMonth(
                PortalMain.ServiceBsBackupController.backupsStartDate.getMonth() - 12
            );
        }
        
        var bsOrderRequest = new PortalRequest;
        bsOrderRequest.pageNumber = submissionData.page;
        bsOrderRequest.makeRequest(
            '/orders-bs/get-bs-resource-backups',
            {
                perPage: PortalMain.ServiceBsBackupController.perPage,
                resourceId: PortalMain.ServiceBsBackupController.resourceId,
                startDate: PortalMain.ServiceBsBackupController.backupsStartDate.getTime() / 1000|0,
                endDate: PortalMain.ServiceBsBackupController.backupsEndDate.getTime() / 1000|0,
            },
            function(data, code) {
                if (code != 'ORDER_BS_NOT_MANAGED') {
                    
                    //handle pagination 
                    PortalMain.ServiceBsBackupController.pagination.updatePagination(data);
                    PortalMain.ServiceBsBackupController.pagination.showPagination();
                    
                    // populate the backups
                    PortalMain.ServiceBsBackupController._populateBackups(data);
                }
            }
        )
    },
    
    // fill and display the backup data for this managed order
    _populateBackups: function(backups) 
    {   
        $('#backups-table tbody tr:not(.clone-source)').remove();
        
        for (var i in backups.data) {
            var backup = backups.data[i];
            
            var newEntry = $('#backups-table .clone-source').clone();
            newEntry.removeClass('clone-source');
            // apply the last backup
            var lastBackup = PortalHelper.formatDate(backup.last_backup);
            lastBackup += ' ' + PortalHelper.formatTime(backup.last_backup);
            $('.last-backup', newEntry).html(lastBackup);
            
            // apply the status
            $('.status', newEntry).html(backup.status);
            
            // add to to the table
            $('#backups-table tbody').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#backups-table', false);
        
    },
    
    // changes what date range is displayed
    _updateBackupsRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#backups-table', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getBsResourceBackups(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateBackupsSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('#backups-range .selection-text').text(selectedElementText);
    },
    
}
